"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPinoBrowserLogEvent = void 0;
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isString(value) {
    return typeof value === 'string';
}
/* istanbul ignore next */
function levelToStatus(level) {
    if (level === 10 || level === 20) {
        return 'debug';
    }
    if (level === 40) {
        return 'warning';
    }
    if (level === 50) {
        return 'error';
    }
    if (level >= 60) {
        return 'critical';
    }
    return 'info';
}
const formatPinoBrowserLogEvent = (logEvent) => {
    const { ts, messages, bindings, level: { value: levelValue } } = logEvent;
    const level = levelToStatus(levelValue);
    const timestamp = ts;
    const objMessages = messages.filter(isObject);
    const strMessages = messages.filter(isString);
    const logEntry = strMessages.join(' ');
    const defaultMetadata = {
        url: window.document.URL,
        level,
        browser: true
    };
    const bindingsAndMessages = bindings.concat(objMessages);
    const metadata = bindingsAndMessages.reduce((acc, el) => {
        return Object.assign(acc, el);
    }, defaultMetadata);
    return {
        metadata,
        log_entry: logEntry,
        timestamp
    };
};
exports.formatPinoBrowserLogEvent = formatPinoBrowserLogEvent;
//# sourceMappingURL=formatPinoBrowserLogEvent.js.map